import React from 'react';

import { getDisplayName } from 'utils/hoc';
import MediaQueriesContext from './MediaQueriesContext';

const withMediaQueries = mapMediaQueryToProps => Component => {
  function WithMediaQueries(props) {
    return (
      <MediaQueriesContext.Consumer>
        {mediaQueries => <Component {...props} {...mapMediaQueryToProps(mediaQueries)} />}
      </MediaQueriesContext.Consumer>
    );
  }

  WithMediaQueries.displayName = `WithMediaQueries(${getDisplayName(Component)})`;
  WithMediaQueries.WrappedComponent = Component;

  return WithMediaQueries;
};

export default withMediaQueries;

export const withMediaQueryDesktop = withMediaQueries(mediaQueries => ({
  isDesktopBreakpoint: mediaQueries.isDesktopBreakpoint,
}));
